import { auth } from '@/shared/lib';
import classNames from 'classnames';
import SupportRequestComment from './supportRequestComment';
import { useSupportRequestDetails } from './useSupportRequestDetails';
import HeaderPage from './headerPage/headerPage';
import SupportRequestInfo from './supportRequestInfo/supportRequestInfo';
import './supportRequestDetails.scss';

/**
 * Detail page of a single support request, showing its header, comment thread and request information side by side. Reads detail and comment data plus the update handlers from useSupportRequestDetails, passes handleReOpen to the header and the comment and email callbacks to the two panels, and adds a marketing-banner class when a marketing or logo banner is displayed.
 *
 * @returns The support request detail page markup.
 */
const SupportRequestDetail = () => {
  const { state, bodyLeft, headerRef, handleUpdateComment, handleUpdateEmail, handleReOpen } =
    useSupportRequestDetails();

  return (
    <div
      ref={headerRef}
      className={classNames('support-request-details-page', {
        'has-marketing-banner': auth.hasMarketingBanner() || auth.hasLogoBanner(),
      })}
    >
      <HeaderPage
        isLoadedData={state.isLoadedData}
        detailData={state.detailData}
        handleReOpen={handleReOpen}
      />
      <div className="body-support-detail-page">
        <div ref={bodyLeft} id="body-left" className="body-left">
          <SupportRequestComment
            detailData={state.detailData}
            commentData={state.commentData}
            isLoadedData={state.isLoadedData}
            handleUpdateComment={handleUpdateComment}
          />
        </div>
        <div id="body-right" className="body-right">
          <SupportRequestInfo
            detailData={state.detailData}
            isLoadedData={state.isLoadedData}
            handleUpdateEmail={handleUpdateEmail}
          />
        </div>
      </div>
    </div>
  );
};

export default SupportRequestDetail;
